import React, { useState, useEffect, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { ListItemText, Box, ButtonGroup, Stack, TextField, FormGroup, FormControlLabel, Paper, Checkbox, Grid, Button, TextareaAutosize } from '@mui/material';

const PropertiePanel = (props) => {
    const { propsId, cards, saveProperties } = props;
    const [hasChange, setHasChange] = useState(false);
    const [properties, setProperties] = useState();
    const [incrementavelFields, setIncrementavelFields] = useState([]); // Estado para campos incrementáveis

    useEffect(() => {
        setHasChange(false);
        if (propsId === -1) return;
        let p = cards[propsId].properties;
        if (!p) {
            p = makeProperties(cards[propsId]);
        }
        setProperties(p);
    }, [propsId])


    const handleChangeProperties = (e) => {
        let p = properties ? [...properties] : [...cards[propsId].properties];
        if (!p) {
            p = makeProperties(cards[propsId]);
        }
        var name = e.target.name.split("_")[1];
        let item = p.find(pp => pp.name === name);
        item.value = e.target.value;
        setProperties(p);
        setHasChange(true);
    }

    function makeProperties(item) {
        let arr = [
            {
                name: 'label',
                value: ''
            },
            {
                name: 'id',
                value: ''
            }
        ];
        if (item.type === 'textField') {
            arr.push({ name: 'placeholder', value: '' });
            arr.push({ name: 'mascara', value: '' });
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
            arr.push({ name: 'incrementavel', value: false });
        }
        if (item.type === 'textFieldMoeda') {
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
        }
        if (item.type === 'dataField') arr.push({ name: 'placeholder', value: '' });
        if (item.type === "textArea") arr.push({ name: 'placeholder', value: '' });
        if (item.type === "upload") {
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
        }
        if (item.type === "checkBox") {
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
            arr.push({ name: 'helperText', value: '' });
        }

        if (item.type === "uploadUnico") {
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
        }
        if (item.type === "radio") {
            arr.push({ name: 'titulo', value: '' });
            arr.push({ name: 'subtitulo', value: '' });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'options', value: [{ id: 1, label: 'Opção 1' }] });
        }
        if (item.type === "radioGroup") {
            // arr.push({ name: 'titulo', value: '' });
            // arr.push({ name: 'subtitulo', value: '' });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'options', value: [{ id: 1, label: 'Opção 1' }] });
        }
        if (item.type === "selectField") {
            // arr.push({ name: 'titulo', value: '' });
            // arr.push({ name: 'subtitulo', value: '' });
            arr.push({ name: 'errorMessage', value: 'Este campo é obrigatório' });
            arr.push({ name: 'helper', value: '' });
            arr.push({ name: 'required', value: false });
            arr.push({ name: 'itens', value: [{ id: 1, label: 'Opção 1' }] });
        }

        return arr;
    }

    const handleClick = () => {
        if (saveProperties) saveProperties(properties);
        setHasChange(false)
    }


    return (
        <Grid>
            <Stack spacing={1} >
                {properties && properties.map((p, i) => {
                    if (p.name === 'required') {
                        return (
                            <FormControlLabel
                                key={i}
                                control={
                                    <Checkbox
                                        checked={p.value}
                                        onChange={(e) => {
                                            let newProperties = [...properties];
                                            newProperties[i].value = e.target.checked;
                                            setProperties(newProperties);
                                            setHasChange(true);
                                        }}
                                        name={'name_' + p.name}
                                    />
                                }
                                label="Obrigatório"
                            />
                        );
                    } else if (p.name === 'incrementavel') {
                        return (
                            <FormControlLabel
                                key={i}
                                control={
                                    <Checkbox
                                        checked={p.value}
                                        onChange={(e) => {
                                            let newProperties = [...properties];
                                            newProperties[i].value = e.target.checked;
                                            setProperties(newProperties);
                                            setHasChange(true);
                                        }}
                                        name={'name_' + p.name}
                                    />
                                }
                                label="Campo Incrementável"
                            />
                        );
                    } else if (p.name === 'errorMessage') {
                        const isRequired = properties.find(prop => prop.name === 'required')?.value || false;
                        if (isRequired) {
                            return (
                                <TextField
                                    key={i}
                                    id={'id_' + p.name}
                                    label="Mensagem de Erro"
                                    variant="outlined"
                                    name={'name_' + p.name}
                                    value={p.value}
                                    size="small"
                                    onChange={handleChangeProperties}
                                />
                            );
                        } else {
                            return null;
                        }
                    } else if (p.name === 'helperText') {
                        return (
                            <TextField
                                id={'id_' + p.name}
                                name={'name_' + p.name}
                                label={p.name}
                                multiline
                                minRows={3}    // Minimum height (rows)
                                maxRows={6}    // Maximum height before scrolling
                                variant="outlined"
                                size="small"
                                value={p.value}
                                helperText="Ajuda do campo"
                                onChange={handleChangeProperties}
                                fullWidth
                            />                            
                        );
                    } else if (p.name === 'titulo' || p.name === 'subtitulo') {
                        return (
                            <TextField
                                key={i}
                                id={'id_' + p.name}
                                label={p.name === 'titulo' ? 'Título' : 'Subtítulo'}
                                variant="outlined"
                                name={'name_' + p.name}
                                value={p.value}
                                size="small"
                                onChange={handleChangeProperties}
                            />
                        );
                    } else if (p.name === 'itens') {
                        return (
                            <Stack key={i}>
                                <p>Itens de seleção</p>
                                {p.value.map((option, index) => (
                                        <div key={option.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
                                            <TextField
                                                label={`Item ${index + 1}`}
                                                variant="outlined"
                                                size="small"
                                                value={option.label}
                                                onChange={(e) => {
                                                    let newProperties = [...properties];
                                                    newProperties[i].value[index].label = e.target.value;
                                                    setProperties(newProperties);
                                                    setHasChange(true);
                                                }}
                                            />
                                            <IconButton
                                                onClick={() => {
                                                    let newProperties = [...properties];
                                                    newProperties[i].value = newProperties[i].value.filter((_, idx) => idx !== index);
                                                    setProperties(newProperties);
                                                    setHasChange(true);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    ))}
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            let newProperties = [...properties];
                                            newProperties[i].value.push({ id: p.value.length + 1, label: `Opção ${p.value.length + 1}` });
                                            setProperties(newProperties);
                                            setHasChange(true);
                                        }}
                                    >
                                        Adicionar Opção
                                    </Button>
                            </Stack>
                        )   
                    }else if (p.name === 'options') {
                            return (
                                <div key={i}>
                                    <label>Opções do Rádio</label>
                                    {p.value.map((option, index) => (
                                        <div key={option.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                            <TextField
                                                label={`Opção ${index + 1}`}
                                                variant="outlined"
                                                size="small"
                                                value={option.label}
                                                onChange={(e) => {
                                                    let newProperties = [...properties];
                                                    newProperties[i].value[index].label = e.target.value;
                                                    setProperties(newProperties);
                                                    setHasChange(true);
                                                }}
                                            />
                                            <IconButton
                                                onClick={() => {
                                                    let newProperties = [...properties];
                                                    newProperties[i].value = newProperties[i].value.filter((_, idx) => idx !== index);
                                                    setProperties(newProperties);
                                                    setHasChange(true);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    ))}
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            let newProperties = [...properties];
                                            newProperties[i].value.push({ id: p.value.length + 1, label: `Opção ${p.value.length + 1}` });
                                            setProperties(newProperties);
                                            setHasChange(true);
                                        }}
                                    >
                                        Adicionar Opção
                                    </Button>
                                </div>
                            );
                        }
                        else {
                            return (
                                <TextField
                                    key={i}
                                    id={'id_' + p.name}
                                    label={p.name}
                                    variant="outlined"
                                    name={'name_' + p.name}
                                    value={p.value}
                                    size="small"
                                    onChange={handleChangeProperties}
                                />
                            );
                        }
                })}
            </Stack>
            <Toolbar>
                {hasChange && (
                    <IconButton aria-label="upload picture" component="span" onClick={handleClick}>
                        <SaveIcon />
                    </IconButton>
                )}
            </Toolbar>
        </Grid>
    );
}


export default PropertiePanel